import React, { Component } from 'react';

import PropTypes from 'prop-types';

import AJAX from 'common/AJAX';
import AuthRequest from 'common/auth/AuthRequest';
import { ViewerContext } from 'common/containers/ViewerContainer';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import Message from 'common/message/Message';
import setCookie from 'common/setCookie';
import devURL from 'common/util/devURL';
import parseJSON from 'common/util/parseJSON';
import withContexts from 'common/util/withContexts';

export const DisconnectAzureContext = React.createContext();
export const DisconnectGoogleContext = React.createContext();
export const OAuthContext = React.createContext();

const Delay = 50;
const Origin = devURL('https://auth.canny.io');
let CannyRegex = /.*canny\.io/gi;
if (__DEV__) {
  CannyRegex = /.*canny\.localhost:[0-9]+/gi;
}
if (__DEV_ENV__) {
  CannyRegex = /.*cannisters\.website/gi;
}
if (__STAGING__) {
  CannyRegex = /.*cannisters\.cafe/gi;
}
const UserIDName = '__canny__userID';
const SessionIDName = '__canny__sessionID';

@withContexts({ viewer: ViewerContext })
export default class AuthContainer extends Component {
  static propTypes = {
    viewer: PropTypes.object,
  };

  state = {
    showAuthFrame: false,
  };

  constructor(props, context) {
    super(props, context);

    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    this._requestID = 1;
    this._callbacks = {};

    setTimeout(() => {
      this.setState({
        showAuthFrame: true,
      });
    }, Delay);
  }

  componentWillUnmount() {
    this._callbacks.length = 0;
  }

  disconnectAzure = () => {
    AJAX.post(
      'https://login.microsoftonline.com/organizations/oauth2/v2.0/logout',
      {},
      (response) => {}
    );
  };

  disconnectGoogle = () => {
    if (!this._googleIDToken) {
      return;
    }

    AJAX.post(
      'https://accounts.google.com/o/oauth2/revoke',
      {
        token: this._googleIDToken,
      },
      (response) => {}
    );
  };

  oauth = (authType, additionalData, callback) => {
    const authRequest = new AuthRequest(authType, additionalData, (error, oauthData) => {
      if (error) {
        callback(error);
        return;
      }

      if (oauthData.googleIDToken) {
        this._googleIDToken = oauthData.googleIDToken;
      }

      callback(null, oauthData);
    });
    authRequest.start();
  };

  onCookies = (authCookies) => {
    if (!authCookies[UserIDName] || !authCookies[SessionIDName]) {
      return;
    }

    AJAX.post(
      '/api/viewer/get',
      {
        [SessionIDName]: authCookies[SessionIDName],
        [UserIDName]: authCookies[UserIDName],
      },
      (response) => {
        parseJSON(response, (error, responseObject) => {
          if (error) {
            return;
          }

          const { viewer } = this.props;
          const { viewer: cannyViewer } = responseObject;
          if (!cannyViewer) {
            return;
          } else if (viewer && viewer._id === cannyViewer._id) {
            return;
          }

          setCookie(UserIDName, authCookies[UserIDName]);
          setCookie(SessionIDName, authCookies[SessionIDName]);
          window.location.reload();
        });
      }
    );
  };

  onFrameLoaded = () => {
    const { host } = window.location;
    if (host.match(CannyRegex)) {
      return;
    }

    const iframe = this.iframeRef.current;
    Message.subscribe(iframe.contentWindow, Origin, 'cannyCookies', this.onCookies);
    Message.postMessage(iframe.contentWindow, Origin, 'verifyDomain', {});
  };

  renderAuthFrame() {
    const { showAuthFrame } = this.state;
    if (!showAuthFrame) {
      return null;
    }

    return (
      <iframe
        ref={this.iframeRef}
        width="0"
        height="0"
        id="canny-auth-frame"
        onLoad={this.onFrameLoaded}
        sandbox="allow-same-origin allow-scripts"
        scrolling="no"
        src={Origin + '/auth.html'}
        style={{
          border: 0,
          display: 'none',
        }}
      />
    );
  }

  render() {
    return (
      <DisconnectAzureContext.Provider value={this.disconnectAzure}>
        <DisconnectGoogleContext.Provider value={this.disconnectGoogle}>
          <OAuthContext.Provider value={this.oauth}>
            <div className="authContainer">
              {cloneElementWithProps(this.props.children, {
                ...this.props,
              })}
              {this.renderAuthFrame()}
            </div>
          </OAuthContext.Provider>
        </DisconnectGoogleContext.Provider>
      </DisconnectAzureContext.Provider>
    );
  }
}
